if (!customElements.get('leafing-kit-offer')) {
  class LeafingKitOffer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    async handleClick(event) {
      const button = event.target.closest('[data-leafing-kit-add]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      const row = button.closest('[data-kit-row]');
      const errorMessage = row.querySelector('[data-kit-error]');
      const status = this.querySelector('[data-kit-status]');
      const originalLabel = button.textContent;
      const kitName = button.dataset.kitName;

      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding…';
      errorMessage.hidden = true;

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
          })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || response.status);

        button.textContent = 'Added ✓';
        status.textContent = `${kitName} added to your cart.`;

        const cartDrawer = document.querySelector('cart-drawer');
        window.setTimeout(() => {
          if (cartDrawer && typeof cartDrawer.refreshCartDrawer === 'function') {
            cartDrawer.refreshCartDrawer(false);
          } else {
            const cartItems = document.querySelector('cart-items');
            if (cartItems && typeof cartItems.refreshCartItems === 'function') cartItems.refreshCartItems();
          }
        }, 700);
      } catch (error) {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel;
        errorMessage.textContent = 'We couldn’t add this kit. Please try again.';
        errorMessage.hidden = false;
      }
    }
  }

  customElements.define('leafing-kit-offer', LeafingKitOffer);
}
